<template>
  <div class="identityInfo" v-loading.fullscreen.lock="sonLoading">
    <div class="info-center">
      <div class="kyc-icon"></div>
      <!-- 需要得到法人的同意才能开立账户。请告诉我们贵公司主要法人的身份 -->
      <div class="title">
        {{
        location == "TERRITORY"
        ? $t("kycFile.identityInfo.tit")
        : $t("kycFile.identityInfo.titSec")
        }}
      </div>
      <lls-form
        :inline="true"
        label-position="top"
        class="demo-ruleForm"
        :model="legalOrDirec"
        :rules="legalOrDirectorRules"
        ref="ruleFormIdenSec"
      >
        <p
          class="sub-title"
        >{{location == "TERRITORY" ? $t('kycFile.identityInfo.legalInfo') : $t('kycFile.identityInfo.directorInfo')}}</p>
        <!-- 请选择证件签发地 -->
        <div class="bg-item">
        <lls-form-item :label="$t('kycFile.identityInfo.certificateIssuingPlace')" prop="certificateIssuingPlaceCode">
          
          <lls-select
            filterable
            clearable
            v-model="legalOrDirec.certificateIssuingPlaceCode"
            :placeholder="$t('common.selectPlaceholder')"
            :disabled="legalOrDirec.managerPerson == 'Y'"
          >
            <lls-option
              v-for="item in countryList"
              :key="item.id"
              :label="item.countryName"
              :value="item.countryCode"
            ></lls-option>
          </lls-select>
        </lls-form-item>
        <lls-form-item :label="$t('kycFile.identityInfo.docType')" prop="identType">
          
          <lls-select
            v-model="legalOrDirec.identType"
            :placeholder="$t('common.selectPlaceholder')"
            :disabled="legalOrDirec.managerPerson == 'Y'"
            clearable
          >
            <lls-option
              v-for="item in certificatesObj"
              :key="item.dictKey"
              :label="item.dispalyName"
              :value="item.dictParam"
            ></lls-option>
          </lls-select>
        </lls-form-item>
       </div>
        <div>
          <!-- 证件正面 -->
          <div
            class="com-word"
            style="width:320px;margin-bottom:0px;"
          ><span class="require">*</span> {{ $t("common.certificateFront") }}</div>
          <kycUpload
            type="half"
            v-if="legalOrDirec.mediaId"
            :mediaId="legalOrDirec.mediaId"
            :limit="1"
            modelCode="MKJ02CONTACT"
            catgId="CCONTACT001"
            @toOcr="ocrEventOne"
            :disabled="legalOrDirec.managerPerson == 'Y'"
            ref="certificateFront"
          ></kycUpload>
        </div>
        <div>
          <!-- 证件反面 -->
          <div
            class="com-word"
            style="width:320px;margin-bottom:0px;"
          ><span class="require">*</span> {{ $t("common.certificateBack") }}</div>
          <kycUpload
            type="half"
            v-if="legalOrDirec.mediaId"
            :mediaId="legalOrDirec.mediaId"
            :limit="1"
            modelCode="MKJ02CONTACT"
            catgId="CCONTACT002"
            :disabled="legalOrDirec.managerPerson == 'Y'"
            ref="certificateBack"
          ></kycUpload>
        </div>
        <div class="bg-item">
        <lls-form-item :label="$t('kycFile.identityInfo.idNum')" prop="identNo">
          
          <lls-input
            type="text"
            v-model.trim="legalOrDirec.identNo"
            clearable
            autocomplete="off"
            maxlength="20"
            @input="changeInput($event)"
            :placeholder="$t('common.inputPlaceholder')"
            :disabled="legalOrDirec.managerPerson == 'Y'"
          ></lls-input>
        </lls-form-item>
        <lls-form-item :label="$t('kycFile.identityInfo.familyName')" prop="lastName">
          
          <lls-input
            type="text"
            v-model.trim="legalOrDirec.lastName"
            clearable
            autocomplete="off"
            maxlength="50"
            @input="changeInput($event)"
            :placeholder="$t('common.inputPlaceholder')"
            :disabled="legalOrDirec.managerPerson == 'Y'"
          ></lls-input>
        </lls-form-item>
        <lls-form-item :label="$t('kycFile.identityInfo.firstName')" prop="firstName">
          
          <lls-input
            type="text"
            v-model.trim="legalOrDirec.firstName"
            clearable
            autocomplete="off"
            maxlength="50"
            @input="changeInput($event)"
            :placeholder="$t('common.inputPlaceholder')"
            :disabled="legalOrDirec.managerPerson == 'Y'"
          ></lls-input>
        </lls-form-item>
        <lls-form-item :label="$t('kycFile.identityInfo.email')" prop="email">
          
          <lls-input
            type="text"
            v-model.trim="legalOrDirec.email"
            clearable
            autocomplete="off"
            maxlength="255"
            :placeholder="$t('common.inputPlaceholder')"
            :disabled="legalOrDirec.managerPerson == 'Y'"
          ></lls-input>
        </lls-form-item>
        <lls-form-item :label="$t('kycFile.identityInfo.phone')" required>
          <div class="telephone-class">
            <lls-form-item prop="phoneAreaCode">
              <lls-select 
                v-model="legalOrDirec.phoneAreaCode" 
                filterable
                clearable
                :placeholder="$t('common.selectPlaceholder')"
                popper-class="country-code-drop"
                :disabled="legalOrDirec.managerPerson == 'Y'"
                :filter-method="fitlerCountry">
                <lls-option
                  v-for="item in countryCodeList"
                  :key="item.countryCode"
                  :label="'+' + item.phoneCode"
                  :value="item.phoneCode">
                  <span>{{ '+' + item.phoneCode + ' ' + ($i18n.locale === 'zh' ? item.chineseName : item.englishName) }}</span>
                </lls-option>
              </lls-select>
            </lls-form-item>
            <lls-form-item prop="phone">
              <lls-input
                type="text"
                v-model.trim="legalOrDirec.phone"
                clearable
                autocomplete="off"
                maxlength="20"
                :placeholder="$t('common.inputPlaceholder')"
                :disabled="legalOrDirec.managerPerson == 'Y'"
                @input="
                  value => (legalOrDirec.phone = value.replace(/[^\d]/g, ''))
                "
              ></lls-input>
            </lls-form-item>

          </div>
          
        </lls-form-item>
      </div>
        <template v-if="location!=='TERRITORY'">
          <div class="sub-title">{{ $t('kycFile.identityInfo.remark') }}</div>
          <div
            class="shareholder remark"
            v-for="(v,index) in legalOrDirec.directList"
            :key="'reark' + index"
          >
            <lls-form-item :label="$t('kycFile.identityInfo.contactName')">
              <lls-input
                type="text"
                v-model.trim="legalOrDirec.directList[index]"
                clearable
                autocomplete="off"
                maxlength="50"
                :placeholder="$t('common.inputPlaceholder')"
              ></lls-input>
            </lls-form-item>
            <div
              class="share-word remark-deleBtn"
              @click="delDirectorName(index)"
            >{{ $t("common.delete") }}</div>
          </div>
          <div class="share-button director">
            <div
              class="share-word"
              @click="handleAddDirectorName"
            >+{{$t('kycFile.identityInfo.moreThanDirector')}}</div>
          </div>
        </template>
      </lls-form>
       <lls-form
        :inline="true"
        label-position="top"
        class="demo-ruleForm"
        :model="dynamicValidateForm"
        :rules="dynamicRules"
        ref="dynamicValidateForm"
      >
    <div class="shareholder" v-for="(table, index) in dynamicValidateForm.beneficiaryList" :key="index">
      <!-- 持股25%以上最终受益人 -->
      <div class="com-word" style="width:720px">
        {{ $t("kycFile.identityInfo.moreThanShareholding") }}
        <span>{{ index + 1 }}</span>
      </div>
      <!-- 请选择最终受益人类型 -->
      <div class="bg-item" style="margin-bottom: 0;padding-bottom: 0">
        <lls-form-item :label="$t('kycFile.identityInfo.beneficiaryType')">
          <div class="requ-red">*</div>
          <lls-radio-group v-model="table.contactRoleType" :disabled="table.managerPerson == 'Y'" @change="handleBenefiContactRoleTypeChange(index)">
            <lls-radio label="COMPANY">{{$t('kycFile.identityInfo.enterprise')}}</lls-radio>
            <lls-radio label="PERSONAL">{{$t('kycFile.identityInfo.personal')}}</lls-radio>
          </lls-radio-group>
        </lls-form-item>
      </div>
      <div v-show="table.contactRoleType === 'PERSONAL'" class="shareholder">
        <div class="bg-item" style="margin-top: 0;padding-top: 0;">
          <lls-form-item :label="$t('kycFile.identityInfo.certificateIssuingPlace')" :prop="'beneficiaryList.' + index + '.certificateIssuingPlaceCode'">
            <lls-select
              filterable
              clearable
              v-model="table.certificateIssuingPlaceCode"
              :placeholder="$t('common.selectPlaceholder')"
              :disabled="table.managerPerson == 'Y'"
            >
              <lls-option
                v-for="item in countryList"
                :key="item.id"
                :label="item.countryName"
                :value="item.countryCode"
              ></lls-option>
            </lls-select>
          </lls-form-item>
          <lls-form-item :label="$t('kycFile.identityInfo.docType')" :prop="'beneficiaryList.' + index + '.identType'">
            <lls-select
              v-model="table.identType"
              :placeholder="$t('common.selectPlaceholder')"
              :disabled="table.managerPerson == 'Y'"
            >
              <lls-option
                v-for="item in certificatesObj"
                :key="item.dictKey"
                :label="item.dispalyName"
                :value="item.dictParam"
              ></lls-option>
            </lls-select>
          </lls-form-item>
        </div>
        <div>
          <div class="com-word" style="width:320px;margin-bottom:0px;"><span class="require">*</span>{{ $t("common.certificateFront") }}</div>
          <kycUpload
            type="half"
            v-if="table.mediaId"
            :mediaId="table.mediaId"
            :limit="1"
            :currentIndex="index"
            modelCode="MKJ02CONTACT"
            catgId="CCONTACT001"
            @toOcr="ocrBeneficiaryEvent"
            :disabled="table.managerPerson == 'Y'"
            ref="beneCertificateFront"
          ></kycUpload>
        </div>
        <div>
          <div class="com-word" style="width:320px;margin-bottom:0px;"><span class="require">*</span>{{ $t("common.certificateBack") }}</div>
          <kycUpload
            type="half"
            v-if="table.mediaId"
            :mediaId="table.mediaId"
            :limit="1"
            modelCode="MKJ02CONTACT"
            catgId="CCONTACT002"
            :disabled="table.managerPerson == 'Y'"
            ref="beneCertificateBack"
          ></kycUpload>
        </div>
        <div class="bg-item">
          <lls-form-item :label="$t('kycFile.identityInfo.idNum')" class="allLine" :prop="'beneficiaryList.' + index + '.identNo'">
            <lls-input
              type="text"
              v-model.trim="table.identNo"
              clearable
              autocomplete="off"
              maxlength="50"
              :placeholder="$t('common.inputPlaceholder')"
              :disabled="table.managerPerson == 'Y'"
            ></lls-input>
          </lls-form-item>
          <lls-form-item :label="$t('kycFile.identityInfo.familyName')" :prop="'beneficiaryList.' + index + '.lastName'">
            <lls-input
              type="text"
              v-model.trim="table.lastName"
              clearable
              autocomplete="off"
              maxlength="50"
              :placeholder="$t('common.inputPlaceholder')"
              :disabled="table.managerPerson == 'Y'"
            ></lls-input>
          </lls-form-item>
          <lls-form-item :label="$t('kycFile.identityInfo.firstName')" :prop="'beneficiaryList.' + index + '.firstName'">
            <lls-input
              type="text"
              v-model.trim="table.firstName"
              clearable
              autocomplete="off"
              maxlength="50"
              :placeholder="$t('common.inputPlaceholder')"
              :disabled="table.managerPerson == 'Y'"
            ></lls-input>
          </lls-form-item>
          <lls-form-item :label="$t('kycFile.identityInfo.gender')" :prop="'beneficiaryList.' + index + '.gender'">
            <lls-radio-group v-model="table.gender">
              <lls-radio label="MALE">{{ $t("kycFile.identityInfo.male") }}</lls-radio>
              <lls-radio label="FEMALE">{{ $t("kycFile.identityInfo.female") }}</lls-radio>
            </lls-radio-group>
          </lls-form-item>
          <lls-form-item :label="$t('kycFile.identityInfo.dateBirth')" :prop="'beneficiaryList.' + index + '.birthday'">
            <lls-date-picker
              v-model="table.birthday"
              type="date"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions0"
              :editable="true"
            ></lls-date-picker>
          </lls-form-item>
        </div>
      </div>
      <div v-show="table.contactRoleType === 'COMPANY'" class="shareholder">
        <div class="bg-item" style="margin-top: 0;padding-top: 0;">
          <lls-form-item :label="$t('kycFile.identityInfo.enterpriseName')" :prop="'beneficiaryList.' + index + '.name'">
            <lls-input
              type="text"
              v-model.trim="table.name"
              clearable
              autocomplete="off"
              maxlength="250"
              :placeholder="$t('common.inputPlaceholder')"
              :disabled="table.managerPerson == 'Y'"
            ></lls-input>
          </lls-form-item>
          <lls-form-item :label="$t('kycFile.identityInfo.enterpriseCertificate')" :prop="'beneficiaryList.' + index + '.companyIdentType'">
            <lls-select
              filterable
              clearable
              v-model="table.companyIdentType"
              :placeholder="$t('common.selectPlaceholder')"
              :disabled="table.managerPerson == 'Y'"
            >
              <lls-option
                v-for="item in companyIdentTypeEnum"
                :key="item.id"
                :label="item.dispalyName"
                :value="item.dictParam"
              ></lls-option>
            </lls-select>
          </lls-form-item>
        </div>
        <div class="com-word" style="width:320px;margin-bottom:5px;">
          <span class="require">*</span>
          {{ $t("kycFile.identityInfo.enterpriseFile") }}
        </div>
        <kycUpload
          :mediaId="table.mediaId"
          modelCode="MKJ02CONTACT"
          catgId="CCONTACT003"
          :limit="5"
          style="margin-bottom:20px;"
          ref="beneEnterpriseFile"
        ></kycUpload>
        <div class="bg-item">
          <lls-form-item :label="$t('kycFile.basicsInfo.companyCode')" :prop="'beneficiaryList.' + index + '.identNo'">
            <lls-input
              type="text"
              v-model="table.identNo"
              clearable
              autocomplete="off"
              maxlength="50"
              :placeholder="$t('common.inputPlaceholder')"
            ></lls-input>
          </lls-form-item>
          <lls-form-item :label="$t('kycFile.basicsInfo.issuedPlaceOfCertificate')" :prop="'beneficiaryList.' + index + '.certificateIssuingPlaceCode'">
            <lls-select
              v-model="table.certificateIssuingPlaceCode"
              filterable
              clearable
              :placeholder="$t('common.selectPlaceholder')"
            >
              <lls-option
                v-for="item in countryList"
                :key="item.id"
                :label="item.countryName"
                :value="item.countryCode"
              ></lls-option>
            </lls-select>
          </lls-form-item>
        </div>
      </div>
      <div class="share-button">
        <div
          class="share-word"
          @click="addShare"
        >{{ $t('kycFile.identityInfo.upTip') }}</div>
        <div
          class="share-word"
          v-if="index != 0"
          @click="delShare(index)"
        >{{ $t("common.delete") }}</div>
      </div>
    </div>
    </lls-form>
        <lls-form
        :inline="true"
        label-position="top"
        class="demo-ruleForm"
        :model="dynamicValidateForm"
        :rules="shareholderDynamicRules"
        ref="shareholderDynamicValidateForm"
      >
        <div
          class="shareholder"
          v-for="(table, index) in dynamicValidateForm.shareholderList"
          :key="'shareholderList'+index"
        >
          <div class="com-word" style="width:720px">
            {{ $t("kycFile.identityInfo.moreThanStockholder")
            }}
            <span>{{ index + 1 }}</span>
          </div>
          <!-- 请选择证件签发地 -->
          <div class="bg-item" style="margin-bottom: 0;padding-bottom: 0">
          <lls-form-item :label="$t('kycFile.identityInfo.stockholderType')">
            <div class="requ-red">*</div>
            <lls-radio-group v-model="table.contactRoleType" :disabled="table.managerPerson == 'Y'" @change="handleContactRoleTypeChange(index)">
              <lls-radio label="COMPANY">{{$t('kycFile.identityInfo.enterprise')}}</lls-radio>// 企业
              <lls-radio label="PERSONAL">{{$t('kycFile.identityInfo.personal')}}</lls-radio>// 个人
            </lls-radio-group>
          </lls-form-item>
        </div>
          <div v-show="table.contactRoleType==='PERSONAL'" class="shareholder">
            <div class="bg-item" style="margin-top: 0;padding-top: 0;">
            <lls-form-item :label="$t('kycFile.identityInfo.certificateIssuingPlace')" :prop="'shareholderList.' + index + '.certificateIssuingPlaceCode'">
              <lls-select
                filterable
                clearable
                v-model="table.certificateIssuingPlaceCode"
                :placeholder="$t('common.selectPlaceholder')"
                :disabled="table.managerPerson == 'Y'"
              >
                <lls-option
                  v-for="item in countryList"
                  :key="item.id"
                  :label="item.countryName"
                  :value="item.countryCode"
                ></lls-option>
              </lls-select>
            </lls-form-item>
            <lls-form-item :label="$t('kycFile.identityInfo.docType')"  :prop="'shareholderList.' + index + '.identType'">
              <lls-select
                v-model="table.identType"
                :placeholder="$t('common.selectPlaceholder')"
                :disabled="table.managerPerson == 'Y'"
              >
                <lls-option
                  v-for="item in certificatesObj"
                  :key="item.dictKey"
                  :label="item.dispalyName"
                  :value="item.dictParam"
                ></lls-option>
              </lls-select>
            </lls-form-item>
          </div>
            <div>
              <!-- 证件正面 -->
              <div class="com-word" style="width:320px;margin-bottom:0px;">
                <span class="require">*</span>
                {{ $t("common.certificateFront") }}
              </div>
              <kycUpload
                type="half"
                :mediaId="table.mediaId"
                :limit="1"
                :currentIndex="index"
                modelCode="MKJ02CONTACT"
                catgId="CCONTACT001"
                @toOcr="ocrShareHolderEvent"
                :disabled="table.managerPerson == 'Y'"
                ref="shareholderCertificateFront"
              ></kycUpload>
            </div>
            <div>
              <!-- 证件反面 -->
              <div class="com-word" style="width:320px;margin-bottom:0px;">
                <span class="require">*</span>
                {{ $t("common.certificateBack") }}
              </div>
              <kycUpload
                type="half"
                :mediaId="table.mediaId"
                :limit="1"
                modelCode="MKJ02CONTACT"
                catgId="CCONTACT002"
                :disabled="table.managerPerson == 'Y'"
                ref="shareholderCertificateBack"
              ></kycUpload>
            </div>
            <div class="bg-item" >
            <lls-form-item :label="$t('kycFile.identityInfo.idNum')" class="allLine" :prop="'shareholderList.' + index + '.identNo'">
              <lls-input
                type="text"
                v-model.trim="table.identNo"
                clearable
                autocomplete="off"
                maxlength="50"
                :placeholder="$t('common.inputPlaceholder')"
                :disabled="table.managerPerson == 'Y'"
              ></lls-input>
            </lls-form-item>
            <lls-form-item :label="$t('kycFile.identityInfo.familyName')" :prop="'shareholderList.' + index + '.lastName'">
              <lls-input
                type="text"
                v-model.trim="table.lastName"
                clearable
                autocomplete="off"
                maxlength="50"
                :placeholder="$t('common.inputPlaceholder')"
                :disabled="table.managerPerson == 'Y'"
              ></lls-input>
            </lls-form-item>
            <lls-form-item :label="$t('kycFile.identityInfo.firstName')" :prop="'shareholderList.' + index + '.firstName'">
              <lls-input
                type="text"
                v-model.trim="table.firstName"
                clearable
                autocomplete="off"
                maxlength="50"
                :placeholder="$t('common.inputPlaceholder')"
                :disabled="table.managerPerson == 'Y'"
              ></lls-input>
            </lls-form-item>
            <lls-form-item :label="$t('kycFile.identityInfo.gender')" :prop="'shareholderList.' + index + '.gender'">
              <lls-radio-group v-model="table.gender">
                <!-- 男女 -->
                <lls-radio label="MALE">{{ $t("kycFile.identityInfo.male") }}</lls-radio>
                <lls-radio label="FEMALE">{{ $t("kycFile.identityInfo.female") }}</lls-radio>
              </lls-radio-group>
            </lls-form-item>
            <!-- 出生日期 -->
            <lls-form-item :label="$t('kycFile.identityInfo.dateBirth')" :prop="'shareholderList.' + index + '.birthday'">
              <lls-date-picker
                v-model="table.birthday"
                type="date"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions0"
                :editable="true"
              ></lls-date-picker>
            </lls-form-item>
          </div>
          </div>
          <div v-show="table.contactRoleType==='COMPANY'" class="shareholder">
            <div class="bg-item" style="margin-top: 0;padding-top: 0;" >
            <lls-form-item :label="$t('kycFile.identityInfo.enterpriseName')" :prop="'shareholderList.' + index + '.name'">
              <lls-input
                type="text"
                v-model.trim="table.name"
                clearable
                autocomplete="off"
                maxlength="250"
                :placeholder="$t('common.inputPlaceholder')"
                :disabled="table.managerPerson == 'Y'"
              ></lls-input>
            </lls-form-item>
            <lls-form-item :label="$t('kycFile.identityInfo.enterpriseCertificate')" :prop="'shareholderList.' + index + '.companyIdentType'">
              <lls-select
                filterable
                clearable
                v-model="table.companyIdentType"
                :placeholder="$t('common.selectPlaceholder')"
                :disabled="table.managerPerson == 'Y'"
              >
                <lls-option
                  v-for="item in companyIdentTypeEnum"
                  :key="item.id"
                  :label="item.dispalyName"
                  :value="item.dictParam"
                ></lls-option>
              </lls-select>
            </lls-form-item>
          </div>
            <div class="com-word" style="width:320px;margin-bottom:5px;">
              <span class="require">*</span>
              {{ $t("kycFile.identityInfo.enterpriseFile") }}
            </div>
            <kycUpload
              :mediaId="table.mediaId"
              modelCode="MKJ02CONTACT"
              catgId="CCONTACT003"
              :limit="5"
              style="margin-bottom:20px;"
              ref="shareholderEnterpriseFile"
            ></kycUpload>
            <div class="bg-item" >
            <lls-form-item :label="$t('kycFile.basicsInfo.companyCode')" :prop="'shareholderList.' + index + '.identNo'">
              <lls-input
                type="text"
                v-model="table.identNo"
                clearable
                autocomplete="off"
                maxlength="50"
                :placeholder="$t('common.inputPlaceholder')"
              ></lls-input>
            </lls-form-item>
            <lls-form-item :label="$t('kycFile.basicsInfo.issuedPlaceOfCertificate')" :prop="'shareholderList.' + index + '.certificateIssuingPlaceCode'">
              <lls-select
                v-model="table.certificateIssuingPlaceCode"
                filterable
                clearable
                :placeholder="$t('common.selectPlaceholder')"
              >
                <lls-option
                  v-for="item in countryList"
                  :key="item.id"
                  :label="item.countryName"
                  :value="item.countryCode"
                ></lls-option>
              </lls-select>
            </lls-form-item>
          </div>
          </div>

          <div class="share-button">
            <div
              class="share-word"
              @click="handleAddShareholder(index)"
            >+{{$t('kycFile.identityInfo.moreThanStockholder')}}</div>
            <!-- 删除 -->
            <div
              class="share-word"
              v-if="table.managerPerson !== 'Y'"
              @click="handleDeleteShareholder(index)"
            >{{ $t("common.delete") }}</div>
          </div>
        </div>
        <div class="share-button">
          <div
            v-if="dynamicValidateForm.shareholderList.length===0"
            class="share-word"
             style="margin-bottom: 20px;"
            @click="handleAddShareholder"
          >+{{$t('kycFile.identityInfo.moreThanStockholder')}}</div>
        </div>
      </lls-form>
    </div>
  </div>
</template>
<script>
import kycUpload from './kycUpload.vue';
export default {
  name: 'identitySecInfo',
  components: { kycUpload },
  data() {
    let validatePass1 = (rule, value, callback) => {
     let regEmail = /^[a-zA-Z0-9\.!#\$%&\'\*\+\/=\?_`\{\|\}\~\-\(\)\$\%\\\|\/\,\<\>\^]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (value == null) {
        // 请输入邮箱
        callback(new Error(this.$t('kycFile.identityInfo.email1')))
      } else if (!regEmail.test(value)) {
        // 邮箱格式错误
        callback(new Error(this.$t('kycFile.identityInfo.emailFormat')))
      } else {
        callback()
      }
    }
    return {
      allOptions:[],
      countryCodeList:[],
      checked: false,
      enterpriseId: sessionStorage.getItem('enterpriseId'),
      location: sessionStorage.getItem('location'),
      companyIdentTypeEnum: JSON.parse(
        sessionStorage.getItem('企业证件类型kj.kyc.CompanyIdentTypeEnum')
      ),
      countryList: [], //国家表
      sonLoading: false,
      manager: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        identType: null,
        identNo: null,
        id: null,
        mediaId: null,
        phoneDisab: false,
        emailDisab: false,
        position: []
      },
      // 法人或董事
      legalOrDirec: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        identType: null,
        identNo: null,
        id: null,
        mediaId: null,
        position: [],
        certificateIssuingPlaceCode: null,
        certificateIssuingPlace: null,
        directList: []
      },
      dynamicValidateForm: {
         beneficiaryList: [
        {
          id: null,
          mediaId: this.getUid(),
          gender: null,
          firstName: null,
          lastName: null,
          birthday: null,
          contactRoleType: 'PERSONAL'
        }
      ],
      shareholderList: [],
      },
      equally: false,
      legalOrDirectorRules: {
         certificateIssuingPlaceCode:  [
            { required: true,message: this.$t('kycFile.identityInfo.certificateIssuingPlace'), trigger: 'change' }
          ],
        identType:  [
          { required: true,message: this.$t('kycFile.identityInfo.docType'), trigger: 'change' }
        ],
        identNo: [
          { required: true, message: this.$t('kycFile.identityInfo.idNum'), trigger: 'blur' }
        ],
        lastName: [
          { required: true, message: this.$t('kycFile.identityInfo.familyName'), trigger: 'blur' }
        ],
        firstName: [
          { required: true, message: this.$t('kycFile.identityInfo.firstName'), trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.$t('kycFile.identityInfo.email'), trigger: 'blur' },
          { validator: validatePass1, trigger: ['change', 'blur'] }
        ],
        phone: [
          { required: true, message: this.$t('kycFile.identityInfo.phone'), trigger: 'blur' }
        ],
        phoneAreaCode:[
          { required: true, message: this.$t('kycFile.identityInfo.areaCode'), trigger: ['blur','change'] }
        ]
      },
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      },
      dynamicRules:{},
      shareholderDynamicRules:{}
    }
  },
  computed: {
    certificatesObj() {
      const storedData = sessionStorage.getItem('证件类型em.ComStepStatus');
      const arr = storedData? JSON.parse(storedData) : [];
      return arr.filter(item =>
        ['CREDENTIALS_ID', 'CREDENTIALS_PASSPORT', 'CREDENTIALS_OTHER'].includes(item['dictParam'])
      );
    },
    positionObj() {
      const storedData = sessionStorage.getItem('公司职位kj.kyc.PositionEnum');
      return storedData? JSON.parse(storedData) : [];
    },
  },
   watch: {
    'dynamicValidateForm.beneficiaryList': {
      deep: true,
      handler() {
        this.updateDynamicRules();
      }
    },
    'dynamicValidateForm.shareholderList': {
    deep: true,
    handler() {
      this.updateShareholderDynamicRules();
    }
  }
  },
  async mounted() {
    this.allOptions = this.countryCodeList
    await this.getCountry();
    await this.getEnterpriseContact();
    this.getCountryCodeList()
  },
  methods: {
    async getCountryCodeList(){
      const res = await this.$http.get(
        ' /kj-kyc/country/listPhoneAreaCode'
      )
      if (res.data.code !== '200') return
      this.countryCodeList = res.data.data
      this.allOptions = this.countryCodeList
    },
    fitlerCountry(val){
      val = val.toLowerCase()
      if(val.includes("+")) {
        this.countryCodeList = this.allOptions
        return
      }
      if(val){
        this.countryCodeList = this.allOptions.filter(item=>item.phoneCode.includes(val) || (this.$i18n.locale === 'zh' ? item.chineseName.toLowerCase() : item.englishName.toLowerCase()).includes(val))
      } else {
        this.countryCodeList = this.allOptions
      }
    },
     updateDynamicRules() {
      const rules = {};
      this.dynamicValidateForm.beneficiaryList.forEach((item, index) => {
        const baseRules = {
          'certificateIssuingPlaceCode': [
            { required: true, message: item.contactRoleType === 'PERSONAL'? this.$t('kycFile.identityInfo.certificateIssuingPlace') : this.$t('kycFile.basicsInfo.issuedPlaceOfCertificate') , trigger: 'change' }
          ],
          'identNo': [
            { required: true, message: item.contactRoleType === 'PERSONAL'? this.$t('kycFile.identityInfo.idNum') : this.$t('kycFile.basicsInfo.companyCode'), trigger: 'blur' }
          ]
        };

        if (item.contactRoleType === 'PERSONAL') {
          rules[`beneficiaryList.${index}.identType`] = [
            { required: true, message: this.$t('kycFile.identityInfo.docType'), trigger: 'change' }
          ];
          rules[`beneficiaryList.${index}.lastName`] = [
            { required: true, message: this.$t('kycFile.identityInfo.familyName'), trigger: 'blur' }
          ];
          rules[`beneficiaryList.${index}.firstName`] = [
            { required: true, message: this.$t('kycFile.identityInfo.firstName'), trigger: 'blur' }
          ];
          rules[`beneficiaryList.${index}.gender`] = [
            { required: true, message: this.$t('kycFile.identityInfo.gender'), trigger: 'change' }
          ];
          rules[`beneficiaryList.${index}.birthday`] = [
            { required: true, message: this.$t('kycFile.identityInfo.dateBirth'), trigger: 'change' }
          ];
        } else if (item.contactRoleType === 'COMPANY') {
          rules[`beneficiaryList.${index}.name`] = [
            { required: true, message: this.$t('kycFile.identityInfo.enterpriseName'), trigger: 'blur' }
          ];
          rules[`beneficiaryList.${index}.companyIdentType`] = [
            { required: true, message: this.$t('kycFile.identityInfo.enterpriseCertificate'), trigger: 'change' }
          ];
        }

        Object.keys(baseRules).forEach(key => {
          rules[`beneficiaryList.${index}.${key}`] = baseRules[key];
        });
      });
      this.dynamicRules = rules;
    },
    updateShareholderDynamicRules() {
    const rules = {};
    this.dynamicValidateForm.shareholderList.forEach((item, index) => {
      const baseRules = {
        'certificateIssuingPlaceCode': [
          { required: true, message: item.contactRoleType === 'PERSONAL'? this.$t('kycFile.identityInfo.certificateIssuingPlace') : this.$t('kycFile.basicsInfo.issuedPlaceOfCertificate') , trigger: 'change' }
        ],
        'identNo': [
          { required: true, message: item.contactRoleType === 'PERSONAL' ? this.$t('kycFile.identityInfo.idNum') : this.$t('kycFile.basicsInfo.companyCode'), trigger: 'blur' }
        ]
      };

      if (item.contactRoleType === 'PERSONAL') {
        rules[`shareholderList.${index}.identType`] = [
            { required: true, message: this.$t('kycFile.identityInfo.docType'), trigger: 'change' }
          ];
        rules[`shareholderList.${index}.lastName`] = [
          { required: true, message: this.$t('kycFile.identityInfo.familyName'), trigger: 'blur' }
        ];
        rules[`shareholderList.${index}.firstName`] = [
          { required: true, message: this.$t('kycFile.identityInfo.firstName'), trigger: 'blur' }
        ];
        rules[`shareholderList.${index}.gender`] = [
          { required: true, message: this.$t('kycFile.identityInfo.gender'), trigger: 'change' }
        ];
        rules[`shareholderList.${index}.birthday`] = [
          { required: true, message: this.$t('kycFile.identityInfo.dateBirth'), trigger: 'change' }
        ];
      } else if (item.contactRoleType === 'COMPANY') {
        rules[`shareholderList.${index}.name`] = [
          { required: true, message: this.$t('kycFile.identityInfo.enterpriseName'), trigger: 'blur' }
        ];
        rules[`shareholderList.${index}.companyIdentType`] = [
          { required: true, message: this.$t('kycFile.identityInfo.enterpriseCertificate'), trigger: 'change' }
        ];
      }

      Object.keys(baseRules).forEach(key => {
        rules[`shareholderList.${index}.${key}`] = baseRules[key];
      });
    });
    this.shareholderDynamicRules = rules;
    },
    handleBenefiContactRoleTypeChange(index) {
      this.updateDynamicRules();
      this.$refs.dynamicValidateForm.validateField(`beneficiaryList.${index}.certificateIssuingPlaceCode`);
      this.$refs.dynamicValidateForm.validateField(`beneficiaryList.${index}.identType`);
      this.$refs.dynamicValidateForm.validateField(`beneficiaryList.${index}.identNo`);
    },
    handleContactRoleTypeChange(index) {
      this.updateShareholderDynamicRules();
      this.$refs.shareholderDynamicValidateForm.validateField(`shareholderList.${index}.certificateIssuingPlaceCode`);
      this.$refs.shareholderDynamicValidateForm.validateField(`shareholderList.${index}.identType`);
      this.$refs.shareholderDynamicValidateForm.validateField(`shareholderList.${index}.identNo`);
    },
    changeInput(e) {
      this.$forceUpdate();
    },
    ocrEventOne(obj) {
      this.$set(this.legalOrDirec, 'identNo', obj.id_number ? obj.id_number : null);
      this.$set(this.legalOrDirec, 'lastName', obj.name ? obj.name.substring(0, 1) : null);
      this.$set(this.legalOrDirec, 'firstName', obj.name ? obj.name.slice(1) : null);
    },
    ocrBeneficiaryEvent(obj, index) {
      const target = this.dynamicValidateForm.beneficiaryList[index];
      this.$set(target, 'identNo', obj.id_number ? obj.id_number : null);
      this.$set(target, 'lastName', obj.name ? obj.name.substring(0, 1) : null);
      this.$set(target, 'firstName', obj.name ? obj.name.slice(1) : null);
    },
    ocrShareHolderEvent(obj, index) {
      const target = this.dynamicValidateForm.shareholderList[index];
      this.$set(target, 'identNo', obj.id_number ? obj.id_number : null);
      this.$set(target, 'lastName', obj.name ? obj.name.substring(0, 1) : null);
      this.$set(target, 'firstName', obj.name ? obj.name.slice(1) : null);
    },
    async getCountry() {
      this.sonLoading = true;
      try {
        const { data } = await this.$API.kycFile.getCountry({});
        this.countryList = data?.data || [];
      } catch (error) {
      } finally {
        this.sonLoading = false;
      }
    },
    async getEnterpriseContact() {
      this.sonLoading = true;
      try {
        const { data } = await this.$API.kycFile.getEnterpriseContact(this.enterpriseId);
        if (data?.code === '200') {
          const contactData = data.data || {};
          if (this.location === 'TERRITORY') {
            if (contactData.legal) {
              const legalData = this.filterObjectDict(contactData.legal);
              legalData.position = legalData.position? this.filterObjectDict(legalData.position) : [];
              legalData.legalPerson = null;
              legalData.mediaId = legalData.mediaId || this.getUid();
              this.legalOrDirec = legalData;
            }
          } else {
            if (contactData.director) {
              const directorData = this.filterObjectDict(contactData.director);
              directorData.position = directorData.position? this.filterObjectDict(directorData.position) : [];
              directorData.mediaId = directorData.mediaId || this.getUid();
              directorData.directList = directorData.directList || [];
              this.legalOrDirec = directorData;
            }
          }
          if (contactData.beneficiaryList) {
            contactData.beneficiaryList.forEach(item => {
              if (!item.contactRoleType) {
                item.contactRoleType = 'PERSONAL';
              }
              if (!item.mediaId) {
                item.mediaId = this.getUid();
              }
              item = this.filterObjectDict(item);
              if (item.position) {
                item.position = [];
              }
            });
            if (contactData.beneficiaryList.length === 0) {
              const benObj = {
                gender: null,
                firstName: null,
                lastName: null,
                birthday: null,
                contactRoleType: 'PERSONAL',
                mediaId: this.getUid()
              };
              contactData.beneficiaryList.push(benObj);
            }
            this.dynamicValidateForm.beneficiaryList = contactData.beneficiaryList;
          }
          if (contactData.stockholderList) {
            contactData.stockholderList.forEach(item => {
              if (!item.contactRoleType) {
                item.contactRoleType = 'PERSONAL';
              }
              if (!item.mediaId) {
                item.mediaId = this.getUid();
              }
              item = this.filterObjectDict(item);
              if (item.position) {
                item.position = [];
              }
            });
            this.dynamicValidateForm.shareholderList = contactData.stockholderList;
          }
        }
      } catch (error) {
      } finally {
        this.sonLoading = false;
      }
    },
    addShare() {
      if (this.dynamicValidateForm.beneficiaryList.length >= 4) {
        return;
      }
      this.dynamicValidateForm.beneficiaryList.push({
        gender: null,
        firstName: null,
        lastName: null,
        birthday: null,
        contactRoleType: 'PERSONAL',
        mediaId: this.getUid()
      });
    },
    delShare(index) {
      this.dynamicValidateForm.beneficiaryList.splice(index, 1);
    },
    handleAddShareholder(index) {
      if (this.dynamicValidateForm.shareholderList.length >= 50) {
        return;
      }
      this.dynamicValidateForm.shareholderList.push({
        contactRoleType: 'PERSONAL',
        mediaId: this.getUid()
      });
    },
    handleDeleteShareholder(index) {
      this.dynamicValidateForm.shareholderList.splice(index, 1);
    },
    handleAddDirectorName() {
      this.legalOrDirec.directList.push('');
    },
    delDirectorName(index) {
      this.legalOrDirec.directList.splice(index, 1);
    },
    async nextSon() {
  try {
    const [isValid1, isValid2, isValid3] = await Promise.all([
      this.$refs['dynamicValidateForm'].validate(),
      this.$refs['ruleFormIdenSec'].validate(),
      this.$refs['shareholderDynamicValidateForm'].validate()
    ]);

    if (!isValid1 || !isValid2 || !isValid3) {
      return;
    }

    // 检查 dynamicValidateForm 中的影像文件
    if (this.dynamicValidateForm.beneficiaryList.length > 0) {
      for (let i = 0; i < this.dynamicValidateForm.beneficiaryList.length; i++) {
        const item = this.dynamicValidateForm.beneficiaryList[i];

        if (item.contactRoleType === 'PERSONAL') {
          if (!this.$refs.beneCertificateFront?.[i]?.fileList?.length) {
            this.$message({
              message: this.$t('kycFile.identityInfo.certificateFrontTip'),
              type: 'warning'
            });
            return;
          }

          if (!this.$refs.beneCertificateBack?.[i]?.fileList?.length) {
            this.$message({
              message: this.$t('kycFile.identityInfo.certificateBackTip'),
              type: 'warning'
            });
            return;
          }
        } else if (item.contactRoleType === 'COMPANY') {
          if (!this.$refs.beneEnterpriseFile?.[i]?.fileList?.length) {
            this.$message({
              message: this.$t('kycFile.identityInfo.enterpriseFile'),
              type: 'warning'
            });
            return;
          }
        }
      }
    }
    // 检查 shareholderDynamicValidateForm 中的影像文件
    if (this.dynamicValidateForm.shareholderList.length > 0) {
      for (let i = 0; i < this.dynamicValidateForm.shareholderList.length; i++) {
        const item = this.dynamicValidateForm.shareholderList[i];
        if (item.contactRoleType === 'PERSONAL') {
          if (!this.$refs.shareholderCertificateFront?.[i]?.fileList?.length) {
            this.$message({
              message: this.$t('kycFile.identityInfo.certificateFrontTip'),
              type: 'warning'
            });
            return;
          }

          if (!this.$refs.shareholderCertificateBack?.[i]?.fileList?.length) {
            this.$message({
              message: this.$t('kycFile.identityInfo.certificateBackTip'),
              type: 'warning'
            });
            return;
          }
        } else if (item.contactRoleType === 'COMPANY') {
          if (!this.$refs.shareholderEnterpriseFile?.[i]?.fileList?.length) {
            this.$message({
              message: this.$t('kycFile.identityInfo.enterpriseFile'),
              type: 'warning'
            });
            return;
          }
        }
      }
    }
    if (!this.$refs.certificateFront?.fileList.length) {
      this.$message({
        message: this.$t('kycFile.identityInfo.certificateFrontTip'),
        type: 'warning'
      });
      return;
    }
    if (!this.$refs.certificateBack?.fileList.length) {
      this.$message({
        message: this.$t('kycFile.identityInfo.certificateBackTip'),
        type: 'warning'
      });
      return;
    }
    this.nextSonAfter();
  } catch (error) {
    console.error("Validation failed:", error);
  }
},
    nextSonAfter() {
      let query = {};
      if (this.location === 'TERRITORY') {
        query = {
          enterpriseId: this.enterpriseId,
          beneficiaryList: this.dynamicValidateForm.beneficiaryList,
          legal: this.legalOrDirec,
          stockholderList: this.dynamicValidateForm.shareholderList
        };
      } else {
        query = {
          enterpriseId: this.enterpriseId,
          beneficiaryList: this.dynamicValidateForm.beneficiaryList,
          director: this.legalOrDirec,
          stockholderList: this.dynamicValidateForm.shareholderList
        };
      }
      this.sonLoading = true;
      this.$API.kycFile.saveEnterpriseContact(query).then(
        data => {
          if (data.data.code === '200') {
            this.$emit('toNext');
          } else {
            this.$message.error(data.data.message);
          }
          this.sonLoading = false;
        }
      ).finally(err=>{
        this.sonLoading = false;
      })
    },
    beforeSon() {
      let query = {};
      if (this.location === 'TERRITORY') {
        query = {
          enterpriseId: this.enterpriseId,
          beneficiaryList: this.dynamicValidateForm.beneficiaryList,
          legal: this.legalOrDirec,
          stockholderList: this.dynamicValidateForm.shareholderList
        };
      } else {
        query = {
          enterpriseId: this.enterpriseId,
          beneficiaryList: this.dynamicValidateForm.beneficiaryList,
          director: this.legalOrDirec,
          stockholderList: this.dynamicValidateForm.shareholderList
        };
      }
      this.sonLoading = true;
      this.$API.kycFile.stagedEnterpriseContact(query).then(
        data => {
          if (data.data.code === '200') {
            this.$emit('toBefore');
          } else {
            this.$message.error(data.data.message);
          }
          this.sonLoading = false;
        },
        error => {
          this.sonLoading = false;
        }
      );
    }
  },
};
</script>
<style lang="scss">
.country-code-drop {
  width: 300px !important;
}
</style>
<style lang="scss" scoped>
@import '../kycCommon.scss';
.identityInfo {
  width: 100%;
  height: 100%;
  white-space: normal;
  .info-center {
    width: 720px;
    margin: 0 auto;
    .telephone-class{
      width: 348px !important;
      display: flex;
      ::v-deep .lls-input {
        &__inner{
          width: 185px;
        }
      }
      ::v-deep .lls-select {
        margin-right: 5px;
        width: 130px !important;
        .lls-input__inner {
          width: 100% !important;
        }
      }
    }
    .kyc-icon {
      width: 44px;
      height: 44px;
      background: url('~@/static/kjaccSonImg/kycIcon.png') center center
        no-repeat;
      margin: 0 auto;
    }
    .title {
      color: rgba(46, 90, 153, 1);
      text-align: center;
      padding: 14px 0 26px 0;
      line-height: 24px;
      font-weight: 600;
      font-size: 20px;
    }
    .sub-title {
      color: rgba(46, 90, 153, 1);
      font-weight: 500;
      width:720px

    }
    .eng-tip {
      font-size: 12px;
      line-height: 20px;
      color: #89929e;
    }
    .com-word {
      font-size: 14px;
      line-height: 20px;
      color: #333333;
    }
    .requ-red {
      position: absolute;
      top: -32px;
      left: 0px;
      color: #ff4c65;
    }
    .require {
      display: inline-block;
      color: #ff4c65;
      font-size: 12px;
      font-weight: normal;
      margin-right: 3px;
    }
    .bg-item {
      padding: 12px 20px;
      margin: 20px 0;
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      background: rgba(247, 251, 255, 1);
    }
    .label-special ::v-deep .lls-form-item__label {
      margin-left: 9px;
    }
    .long-term {
      width: 320px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 28px;
      .term-word {
        font-size: 14px;
        line-height: 20px;
        color: #333333;
        margin-left: 8px;
        margin-top: 1px;
      }
    }
    .shareholder {
      width: 720px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-bottom: 20px;
      align-items: center;
      .share-button {
        display: flex;
        justify-content: flex-start;
        width: 720px;
        .share-word {
          color: #3e8cfa;
          cursor: pointer;
          margin-right: 10px;
          border: 1px solid #3e8cfa;
          padding: 2px 24px;
        }
      }
    }
    .remark-title {
      width: 100%;
    }
    .director {
      padding: 10px 0;
    }
    .remark {
      position: relative;
      margin: 0;
      .remark-deleBtn {
        position: absolute;
        left: 336px;
        bottom: 6px;
      }
    }
    ::v-deep .lls-form-item__label {
      margin-left: 9px;
    }
    .requ-red {
      position: absolute;
      top: -32px;
      left: 0px;
      color: #ff4c65;
    }
    .lit-title-com {
      width: 400px;
      height: 36px;
      display: flex;
      justify-content: flex-start;
      .left-title {
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        color: #333333;
      }
      .item-check {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 15px;
        .check-word {
          font-size: 14px;
          line-height: 20px;
          color: #333333;
          margin-left: 8px;
          margin-top: 1px;
        }
      }
    }
  }
  .allLine {
    width: 100%;
    .lls-input {
      width: 320px;
    }
  }
  .share-word {
    color: #3e8cfa;
    cursor: pointer;
    margin-right: 10px;
    border: 1px solid #3e8cfa;
    padding: 2px 24px;
    border-radius: 4px;
  }
}
</style>